var _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormulaAttribute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 328.68,
    height: 79.229,
    viewBox: "0 0 86.964 20.963",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.6458 -2.6458)",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("g", {
    fontFamily: "'Source Code Pro'",
    fontSize: "2.6458px",
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("text", {
    x: 4.9609375,
    y: 19.47271,
    fill: "#392781",
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 4.9609375,
    y: 19.47271,
    fill: "#0058ff",
    fontFamily: "'Source Code Pro'",
    fontSize: "2.6458px",
    strokeWidth: 0.26458
  }, "}"))), /*#__PURE__*/React.createElement("text", {
    x: 8.2263718,
    y: 15.768544,
    fill: "#392781",
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 8.2263718,
    y: 15.768544,
    strokeWidth: 0.26458
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#0058ff",
    fontFamily: "'Source Code Pro'",
    fontSize: "2.6458px"
  }, "return"), " contact.firstName ", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fontFamily: "'Source Code Pro'",
    fontSize: "2.6458px"
  }, "+"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#3e560f",
    fontFamily: "'Source Code Pro'",
    fontSize: "2.6458px"
  }, "\" \""), " + contact.lastName", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fontFamily: "'Source Code Pro'",
    fontSize: "2.6458px"
  }, ";")))), /*#__PURE__*/React.createElement("text", {
    x: 8.2047291,
    y: 11.937998,
    fill: "#11ee79",
    stroke: "#800000",
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 8.2047291,
    y: 11.937998,
    fill: "#00a840",
    fontSize: "2.6458px",
    stroke: "none",
    strokeWidth: 0.26458
  }, "// Add the first and last names")))), /*#__PURE__*/React.createElement("text", {
    x: 5.1117501,
    y: 8.2867479,
    fill: "#392781",
    fontFamily: "'Source Code Pro'",
    fontSize: "2.3151px",
    strokeWidth: 0.26458,
    style: {
      lineHeight: 0,
      textDecorationColor: "#000000"
    },
    xmlSpace: "preserve"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 5.1117501,
    y: 8.2867479
  }, /*#__PURE__*/React.createElement("tspan", {
    fill: "#0058ff",
    fontSize: "2.6458px"
  }, "export default function("), "contact", /*#__PURE__*/React.createElement("tspan", {
    fill: "#000000",
    fontSize: "2.6458px"
  }, ":"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#6679cc",
    fontSize: "2.6458px"
  }, "Contact"), /*#__PURE__*/React.createElement("tspan", {
    fill: "#0058ff",
    fontSize: "2.6458px"
  }, ") {"))), _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 5.1117501,
    y: 8.2867479,
    fill: "#0058ff"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.0585,
    y: 3.0585,
    width: 86.138,
    height: 20.137,
    rx: 0.79375,
    ry: 0.79375,
    fill: "none",
    stroke: "#aaa",
    strokeWidth: 0.29612
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormulaAttribute);
export default __webpack_public_path__ + "static/media/formula-attribute.e1dd99d43a4d6192c66061950a5ec95a.svg";
export { ForwardRef as ReactComponent };